import { render, staticRenderFns } from "./multiItem.vue?vue&type=template&id=33646902&"
import script from "./multiItem.vue?vue&type=script&lang=js&"
export * from "./multiItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports